import React from "react";
import styles from "./Administration.module.scss";
import CardRow from "../../components/_shared/card-row/CardRow";

const AdministrationData = [
  {
    title: "DEPARTAMENTI TEKNIK",
    email: "departamentiteknik@ffk-kosova.com",
    phoneNumber: "",
    items: [
      {
        title: "Kombëtarja U-15",
        email: "u-15@ffk-kosova.com",
        phoneNumber: "049 97 90 17",
      },
      {
        title: "Kombëtarja U-17",
        email: "u-17@ffk-kosova.com",
        phoneNumber: "049 97 90 17",
      },
      {
        title: "Kombëtarja U-19",
        email: "u-19@ffk-kosova.com",
        phoneNumber: "049 97 90 24",
      },
      {
        title: "Kombëtarja U-21",
        email: "u-21@ffk-kosova.com",
        phoneNumber: "049 97 90 15",
      },
      {
        title: "Kombëtarja A Femrat",
        email: "womennationalteam@ffk-kosova.com",
        phoneNumber: "049 97 90 16",
      },
      {
        title: "Kombëtarja U19 Femrat",
        email: "",
        phoneNumber: "049 97 98 92",
      },
      {
        title: "Kombëtarja U17 Femrat",
        email: "",
        phoneNumber: "044 20 79 93",
      },
      {
        title: "Kombëtarja U15 Femrat",
        email: "",
        phoneNumber: "044 66 27 93",
      },
      {
        title: "Kombëtarja Futsall",
        email: "futsall@ffk-kosova.com",
        phoneNumber: "044 24 96 66",
      },
    ],
  },
  {
    title: "EDUKIMI I TRAJNERËVE",
    email: "departamentiteknik@ffk-kosova.com",
    phoneNumber: "044 20 79 93",
  },
  {
    title: "DEPARTAMENTI I GARAVE",
    email: "",
    phoneNumber: "",
    items: [
      {
        title: "Superliga, Liga e parë dhe U21",
        email: "agronshosholli@ffk-kosova.com",
        phoneNumber: ""
      },
      {
        title: "Liga e dytë dhe Superliga U17",
        email: "liridonbajrami@ffk-kosova.com",
        phoneNumber: ""
      },
      {
        title: "Superliga U19 dhe Liga e parë U19",
        email: "valonsadiku@ffk-kosova.com",
        phoneNumber: ""
      },
      {
        title: "Superliga, Liga e parë dhe U17-vajzat",
        email: "bujarabdullahu@ffk-kosova.com",
        phoneNumber: ""
      },
    ],
  },
  {
    title: "DEPARTAMENTI LIGJOR",
    email: "legal@ffk-kosova.com",
    phoneNumber: "",
  },
  {
    title: "DEPARTAMENTI I MEDIAVE DHE MARKETINGUT",
    email: "marketing@ffk-kosova.com / press@ffk-kosova.com",
    phoneNumber: "",
  },
  {
    title: "DEPARTAMENTI I REGJISTRIMIT",
    email: "dardansadiku@ffk-kosova.com",
    phoneNumber: "",
  },
  {
    title: "DEPARTAMENTI I FINANCAVE",
    email: "financat@ffk-kosova.com",
    phoneNumber: "",
  },
];

const Administration = () => {
  return (
    <div className={styles.MainWrapper}>
      <div className={styles.PrimaryTitleWrapper}>
        <h1>Administrata</h1>
      </div>
      <div className={styles.ListWrapper}>
        {AdministrationData.map((data) => (
          <div>
            <CardRow
              data={{
                title: data.title,
                navigationLink: {
                  link:
                    data.email && data.phoneNumber
                      ? `${data.email} | ${data.phoneNumber}`
                      : `${data.email}`,
                  onLinkClick: () => undefined,
                },
              }}
              colors="BLUE"
              withoutIcon
            />
            {data.items?.map((item) => (
              <div className={styles.ListItem}>
                <p>{item.title}</p>
                {(item.email || item.phoneNumber) && (
                  <span>
                    {item.email && item.phoneNumber
                      ? `${item.email} | ${item.phoneNumber}`
                      : item.email
                        ? item.email
                        : item.phoneNumber}
                  </span>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Administration;
